const Refresh = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11H7.101L7.102 10.991C7.23257 10.3516 7.48813 9.74434 7.854 9.20399C8.39845 8.4018 9.16215 7.77315 10.054 7.39299C10.356 7.26499 10.671 7.16699 10.992 7.10199C11.6579 6.96698 12.3441 6.96698 13.01 7.10199C13.967 7.29808 14.8451 7.7714 15.535 8.46299L16.951 7.05099C16.3128 6.41262 15.5578 5.90303 14.727 5.54999C14.3033 5.37062 13.8628 5.23394 13.412 5.14199C12.4818 4.953 11.5232 4.953 10.593 5.14199C10.1419 5.23432 9.70101 5.37133 9.277 5.55099C8.02753 6.08109 6.95793 6.96108 6.197 8.08499C5.68489 8.84284 5.32676 9.69398 5.143 10.59C5.115 10.725 5.1 10.863 5.08 11H2L6 15L10 11ZM14 13H16.899L16.898 13.008C16.6367 14.2898 15.8812 15.4171 14.795 16.146C14.2548 16.5122 13.6475 16.7677 13.008 16.898C12.3424 17.033 11.6566 17.033 10.991 16.898C10.3516 16.7674 9.74435 16.5119 9.204 16.146C8.93862 15.9665 8.69085 15.7622 8.464 15.536L7.05 16.95C7.68851 17.5882 8.44392 18.0974 9.275 18.45C9.699 18.63 10.142 18.767 10.59 18.858C11.5198 19.0471 12.4782 19.0471 13.408 18.858C15.2005 18.4859 16.7773 17.4294 17.803 15.913C18.3146 15.1557 18.6724 14.3053 18.856 13.41C18.883 13.275 18.899 13.137 18.919 13H22L18 8.99999L14 13Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Refresh;
